<template>
  <div class="vgnes-citizen-office-monitor">
    <section class="office-info-panel">
      <header class="office-header">
        <img class="vgnes-logo" src="../vgBadNeustadtOutdoorMonitor/logo-vgem-bad-neustadt.svg" alt="Verwaltungsgemeinschaft Bad Neustadt a. d. Saale">
        <h1>{{ officeContent.headlineTop }}</h1>
      </header>

      <div class="office-columns">
        <article class="office-column office-column-left">
          <div>
            <h2>{{ officeContent.headlineLeft }}</h2>
            <div class="office-text" v-html="officeContent.textLeft"></div>
          </div>
          <div class="room-hint">
<!--            <span>Zimmer</span>-->
            <span class="direction-arrow" :class="getDirectionClass(officeContent.directionLeft)" v-if="officeContent.directionLeft">
              <svg id="uuid-757595a5-78b0-4b15-a450-50ac5c4963ff" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.05 11.55">
                <path d="M15.58,3.07H6.46V.47c0-.19-.11-.36-.28-.43-.17-.07-.37-.04-.51.09L.14,5.44c-.09.09-.14.21-.14.34s.05.25.14.34l5.52,5.31c.09.09.21.13.32.13.06,0,.12-.01.18-.04.17-.07.28-.24.28-.43v-2.61h9.13c.26,0,.47-.21.47-.47V3.54c0-.26-.21-.47-.47-.47Z" fill="currentColor"/>
              </svg>
            </span>
            <strong>{{ officeContent.roomLeft }}</strong>
          </div>
        </article>

        <article class="office-column office-column-right">
          <div>
            <h2>{{ officeContent.headlineRight }}</h2>
            <div class="office-text" v-html="officeContent.textRight"></div>
          </div>
          <div class="room-hint">
<!--            <span>Zimmer</span>-->
            <strong>{{ officeContent.roomRight }}</strong>
            <span class="direction-arrow" :class="getDirectionClass(officeContent.directionRight)" v-if="officeContent.directionRight">
              <svg id="uuid-757595a5-78b0-4b15-a450-50ac5c4963ff" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.05 11.55">
                <path d="M15.58,3.07H6.46V.47c0-.19-.11-.36-.28-.43-.17-.07-.37-.04-.51.09L.14,5.44c-.09.09-.14.21-.14.34s.05.25.14.34l5.52,5.31c.09.09.21.13.32.13.06,0,.12-.01.18-.04.17-.07.28-.24.28-.43v-2.61h9.13c.26,0,.47-.21.47-.47V3.54c0-.26-.21-.47-.47-.47Z" fill="currentColor"/>
              </svg>
            </span>
          </div>
        </article>
      </div>
    </section>

    <section class="citizen-news-panel">
      <header>
        <p>Neuigkeiten Bürgerbüro</p>
        <h2>{{ currentNews.title }}</h2>
      </header>

      <div class="news-meta">
        <span v-if="currentNews.date">{{ currentNews.date }}</span>
        <strong v-if="currentNews.subtitle">{{ currentNews.subtitle }}</strong>
      </div>

      <img v-if="currentNews.image" :src="currentNews.image" alt="" @load="recalculateNewsPages">

      <div class="news-text-viewport" ref="newsTextViewport">
        <div
            class="news-text-scroller"
            ref="newsTextScroller"
            :style="{ transform: 'translateY(-' + currentNewsOffset + 'px)' }"
            v-html="currentNews.text"
        ></div>
      </div>

      <footer class="news-progress" v-if="newsSlides.length > 1 || newsPageOffsets.length > 1">
        <span
            v-for="(item, index) in newsSlides"
            :key="item.title + index"
            :class="{ active: index === currentNewsIndex }"
        ></span>
      </footer>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";

const CITIZEN_NEWS_UUID = 'a1de9d7b-8131-4d93-b3f7-17bf1f569917'
const CITIZEN_NEWS_URL = `https://aht1gh-api.sqronline.de/api/modules/news/getnews?module_division_uuid=${CITIZEN_NEWS_UUID}&newsTextAsHtml=true`
const SLIDE_INTERVAL_MS = 10000

export default {
  name: "VgBadNeustadtCitizenOfficeMonitor",
  data () {
    return {
      citizenNews: [],
      currentNewsIndex: 0,
      currentNewsPage: 0,
      newsPageOffsets: [0],
      newsInterval: null,
      resizeHandler: null
    }
  },
  computed: {
    ...mapGetters({
      getCurrentViewContent: 'getCurrentViewContent'
    }),
    content () {
      return this.getCurrentViewContent || {}
    },
    officeContent () {
      // Diese Feldnamen entsprechen dem speziell für den Bürgerbüro-Monitor gepflegten indisigno-Backend.
      return {
        headlineTop: this.content.headline1_top || 'Bürgerbüro',
        headlineLeft: this.content.headline2_left || 'Bürgerbüro / Ordnungsamt',
        textLeft: this.content.text1_left || this.fallbackLeftText,
        roomLeft: this.content.room1_left || '001',
        directionLeft: this.normalizeDirection(this.content.direction_left_column),
        headlineRight: this.content.headline3_right || 'Renten / Soziales, Friedhofswesen',
        textRight: this.content.text2_right || this.fallbackRightText,
        roomRight: this.content.room2_right || '003 / 004',
        directionRight: this.normalizeDirection(this.content.direction_right_column)
      }
    },
    fallbackLeftText () {
      return '<p>Pass-, Ausweis- und Meldewesen</p><p>Gewerbe- und Gaststättenrecht</p><p>Fischerei, Fundsachen</p><p>Öffentliche Sicherheit und Ordnung</p>'
    },
    fallbackRightText () {
      return '<p>Rentenangelegenheiten</p><p>Sozialangelegenheiten</p><p>Bestattungs- und Friedhofswesen</p><p>Feuerschutz</p>'
    },
    newsSlides () {
      return this.citizenNews.length > 0 ? this.citizenNews : this.fallbackNewsSlides
    },
    currentNews () {
      return this.newsSlides[this.currentNewsIndex] || this.fallbackNewsSlides[0]
    },
    currentNewsOffset () {
      return this.newsPageOffsets[this.currentNewsPage] || 0
    },
    fallbackNewsSlides () {
      return [
        {
          title: 'Aktuelle Hinweise aus dem Bürgerbüro',
          subtitle: 'Informationen zu Öffnungszeiten, Wahlen und Services',
          text: '<p>Hier erscheinen die letzten fünf Einträge aus der Homepage-Rubrik „Neuigkeiten Bürgerbüro“.</p>',
          date: '',
          image: ''
        }
      ]
    }
  },
  methods: {
    async loadCitizenNews () {
      try {
        const response = await axios.get(CITIZEN_NEWS_URL)
        const rows = this.normalizeSqronlineNews(response.data && response.data.data)

        if (rows.length > 0) {
          this.citizenNews = rows.slice(0, 5)
          this.currentNewsIndex = 0
          this.currentNewsPage = 0
        }
      } catch (error) {
        // Fallback bleibt sichtbar, falls die API am Display nicht erreichbar ist.
        console.warn('VG NES Bürgerbüro-News konnten nicht von sqronline geladen werden.', error)
      }
    },
    normalizeSqronlineNews (value) {
      if (!Array.isArray(value)) {
        return []
      }

      return value
          .map(item => ({
            title: this.cleanText(item.news_title || item.title),
            subtitle: this.cleanText(item.news_subtitle || item.subtitle),
            text: item.news_text || item.text || '',
            date: this.formatDate(item.news_date || item.news_datetime || item.created_at),
            image: this.getSqronlineImageUrl(item)
          }))
          .filter(item => item.title || item.text)
    },
    getSqronlineImageUrl (item) {
      if (item.set_title_image && item.set_title_image[0] && item.set_title_image[0].direct_url) {
        return item.set_title_image[0].direct_url
      }

      return item.image_url || item.direct_url || ''
    },
    cleanText (value) {
      if (value === null || value === undefined) {
        return ''
      }

      return String(value).replace(/\s+/g, ' ').trim()
    },
    formatDate (value) {
      if (!value) {
        return ''
      }

      const date = new Date(value)

      if (isNaN(date.getTime())) {
        return this.cleanText(value)
      }

      return date.toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'})
    },
    normalizeDirection (value) {
      const direction = String(value || '').trim()

      return direction === '0' ? '' : direction
    },
    getDirectionClass (direction) {
      // Entspricht Notice.vue: 1=rechts, 2=unten, 3=links, 4=oben.
      if (direction === '1') return 'is-right'
      if (direction === '2') return 'is-down'
      if (direction === '3') return 'is-left'
      if (direction === '4') return 'is-up'

      return ''
    },
    advanceNews () {
      if (this.currentNewsPage < this.newsPageOffsets.length - 1) {
        this.currentNewsPage++
        return
      }

      this.currentNewsIndex = (this.currentNewsIndex + 1) % this.newsSlides.length
      this.currentNewsPage = 0
      this.recalculateNewsPages()
    },
    recalculateNewsPages () {
      this.$nextTick(() => {
        const viewport = this.$refs.newsTextViewport
        const scroller = this.$refs.newsTextScroller

        if (!viewport || !scroller || viewport.clientHeight <= 0) {
          this.newsPageOffsets = [0]
          return
        }

        const pageHeight = this.getLineAlignedPageHeight(viewport, scroller)
        const pageCount = Math.max(1, Math.ceil(scroller.scrollHeight / pageHeight))

        this.newsPageOffsets = Array.from({length: pageCount}, (item, index) => index * pageHeight)

        if (this.currentNewsPage > this.newsPageOffsets.length - 1) {
          this.currentNewsPage = 0
        }
      })
    },
    getLineAlignedPageHeight (viewport, scroller) {
      const viewportHeight = viewport.clientHeight
      const style = window.getComputedStyle(scroller)
      const parsedLineHeight = parseFloat(style.lineHeight)
      const fallbackLineHeight = parseFloat(style.fontSize) * 1.32
      const lineHeight = parsedLineHeight || fallbackLineHeight

      if (!lineHeight || lineHeight <= 0) {
        return viewportHeight
      }

      // Seitenwechsel erfolgen auf ganzen Zeilen, damit unten/oben keine angeschnittenen Textzeilen sichtbar werden.
      return Math.max(lineHeight, Math.floor(viewportHeight / lineHeight) * lineHeight)
    }
  },
  watch: {
    currentNews () {
      this.currentNewsPage = 0
      this.recalculateNewsPages()
    }
  },
  mounted () {
    this.loadCitizenNews()
    this.recalculateNewsPages()
    this.newsInterval = setInterval(this.advanceNews, SLIDE_INTERVAL_MS)
    this.resizeHandler = () => this.recalculateNewsPages()
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy () {
    clearInterval(this.newsInterval)
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>

<style scoped>
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  src: url('/fonts/vg_nes/Poppins-Light.ttf') format("truetype")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url('/fonts/vg_nes/Poppins-Regular.ttf') format("truetype")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: url('/fonts/vg_nes/Poppins-Medium.ttf') format("truetype")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: url('/fonts/vg_nes/Poppins-Bold.ttf') format("truetype")
}

.vgnes-citizen-office-monitor {
  --vg-blue: #155c86;
  --vg-blue-dark: #0c4262;
  --vg-border: #174a67;
  --vg-muted: #6d6e71;
  --vg-panel: #f4f4f4;
  --vg-text: #151515;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: grid;
  grid-template-columns: 50vw 50vw;
  color: var(--vg-text);
  background: #ffffff;
  font-family: "Poppins",sans-serif;
}

.office-info-panel {
  /* Grid-/Flex-Kinder duerfen nicht anhand langer News-Texte wachsen, damit beide Display-Haelften stabil 100vh behalten. */
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /*padding: 5.1vh 3.4vw 4.8vh 4.1vw;*/
  padding: 4.5vh 2.4vw 4.8vh 2.4vw;
  /*background: linear-gradient(135deg, #ffffff 0%, #ffffff 56%, #f0f4f7 100%);*/
}

.office-header {
  display: grid;
  grid-template-columns: 12.8vw 1fr;
  align-items: center;
  gap: 2.4vw;
  /*min-height: 14vh;*/
  min-height: 7vh;
}

.vgnes-logo {
  width: 12.8vw;
}

.office-header h1 {
  margin: 0;
  color: var(--vg-blue-dark);
  font-size: 3.45vw;
  font-weight: 700;
  line-height: 1.05;
}

.office-columns {
  position: relative;
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  margin-top: 5.8vh;
  /*border: 0.24vw solid var(--vg-border);
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 2vh 5vh rgba(0, 0, 0, 0.08);*/
}

.office-columns::before {
  content: "";
  position: absolute;
  /*top: 7.5vh;*/
  /*bottom: 12vh;*/
  top:0;
  bottom: 0;
  left: 50%;
  width: 0.18vw;
  transform: translateX(-50%);
  background: var(--vg-border);
}

.office-column {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /*padding: 6.1vh 2.8vw 5.4vh;*/
  /*padding: 1vh 0.8vw 1vh;*/
}

.office-column-left {
  padding-right: 0.8vw;
}

.office-column-right {
  padding-left: 0.8vw;
}

.office-column h2 {
  margin: 0 0 3vh;
  color: var(--vg-blue-dark);
  font-size: 2.25vw;
  font-weight: 700;
  line-height: 1.12;
}

.office-text {
  color: #1f1f1f;
  font-size: 1.34vw;
  font-weight: 300;
  line-height: 1.44;
}

.office-text >>> p {
  margin: 0 0 1.3vh;
  line-height:1.32;
}

.office-text >>> ul {
  margin: 0;
  padding-left: 1.5vw;
}

.office-text >>> li {
  margin-bottom: 0.75vh;
}

.office-text >>> p strong {
  font-weight:700;
}

.room-hint {
  display: flex;
  align-items: center;
  /*justify-content: space-between;*/
  gap: 1.4vw;
  color: var(--vg-blue-dark);
}

.office-column-right .room-hint {
  justify-content: flex-end;
}

.room-hint span {
  font-size: 1.35vw;
  font-weight: 500;
}

.room-hint .direction-arrow {
  color: #125481;
  display: block;
  width: 4.3vw;
  height: 5vh;
  transform-origin: center;
}

.direction-arrow svg {
  display: block;
  width: 100%;
  height: 100%;
}

.direction-arrow.is-down {
  transform: rotate(-90deg); /* original arrow svg shows to left */
}

.direction-arrow.is-right {
  transform: rotate(180deg); /* original arrow svg shows to left */
}

.direction-arrow.is-up {
  transform: rotate(90deg); /* original arrow svg shows to left */
}

.room-hint strong {
  /*font-size: 4.8vw;*/
  font-size: 1.8vw;
  font-weight: 700;
  line-height: 0.92;
}

.citizen-news-panel {
  position: relative;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /*padding: 7.2vh 4.45vw 5.1vh;*/
  padding: 4.5vh 4.45vw 5.1vh;
  color: #ffffff;
  background: radial-gradient(circle at 94% 3%, rgba(255, 255, 255, 0.18) 0, rgba(255, 255, 255, 0) 24vw), linear-gradient(155deg, var(--vg-blue) 0%, var(--vg-blue-dark) 100%);
  border-left: 0.7vw solid #ffffff;
}

.citizen-news-panel header p {
  margin: 0 0 2.1vh;
  font-size: 1.25vw;
  font-weight: 500;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.citizen-news-panel header,
.news-meta,
.citizen-news-panel > img,
.news-progress {
  flex: 0 0 auto;
}

.citizen-news-panel header h2 {
  margin: 0;
  font-size: 3.2vw;
  font-weight: 700;
  line-height: 1.08;
  text-transform: uppercase;
}

.news-meta {
  display: flex;
  flex-direction: column;
  gap: 0.8vh;
  margin-top: 3vh;
  font-size: 1.35vw;
  line-height: 1.28;
}

.news-meta span,
.news-meta strong {
  font-weight: 700;
}

.citizen-news-panel img {
  width: 100%;
  max-height: 32vh;
  object-fit: cover;
  margin: 3.2vh 0 0;
}

.news-text-viewport {
  position: relative;
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  margin-top: 3.2vh;
}

.news-text-scroller {
  font-size: 1.34vw;
  font-weight: 300;
  line-height: 1.32;
  transition: transform 0.55s ease;
}

.news-text-scroller >>> p {
  margin: 0 0 1.25vh;
}

.news-text-scroller >>> ul {
  margin: 0 0 1.25vh;
  padding-left: 1.7vw;
}

.news-text-scroller >>> li {
  margin-bottom: 0.7vh;
}

.news-text-scroller >>> img {
  max-width: 100%;
  height: auto;
}

.news-progress {
  display: flex;
  gap: 0.5vw;
  justify-content: center;
  height: 2vh;
  margin-top: 2.3vh;
}

.news-progress span {
  width: 0.7vw;
  height: 0.7vw;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.36);
}

.news-progress span.active {
  background: #ffffff;
}
</style>
